import {
    ProvidersAuthSuiteService,
    ProvidersFiltersType,
    LogoSchema,
    GetMvpdProviderResponseType,
    GetMvpdProviderRequestAuthSuite,
    GetMvpdProvidersResponseType,
} from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteProvidersService {
    constructor() {
        this.providersService = new ProvidersAuthSuiteService();
    }

    /**
     * Fetch list of Providers which offers free preview
     *
     * @param {string} logoSchema - Logo schema value required to get picker logos in a response
     * @returns {Promise<GetMvpdProvidersResponseType>} - get MVPD Providers Response Object of totalCount which is optional number and providers array
     */
    fetchFreePreviewProviders = (logoSchema = LogoSchema.Color) => {
        return this.providersService
            .getMvpdProviders({
                logoSchema,
                filterType: ProvidersFiltersType.FreePreview,
            })
            .then((resp) => {
                return resp.providers;
            });
    };

    /**
     * @param {string} logoSchema - Logo schema value required to get picker logos in a response
     * @returns {Promise<GetMvpdProvidersResponseType>} - Promise of topProviders and allProviders arrays
     */
    fetchProviders = async (logoSchema = LogoSchema.Color) => {
        const allProviders = await this.providersService
            .getMvpdProviders({
                logoSchema,
                filterType: ProvidersFiltersType.NoFilter,
            })
            .then((resp) => {
                return resp.providers;
            });

        const topProviders = await this.providersService
            .getMvpdProviders({
                logoSchema,
                filterType: ProvidersFiltersType.Top,
            })
            .then((resp) => {
                return resp.providers;
            });

        return {
            topProviders,
            allProviders,
        };
    };

    /**
     * * Fetch Provider
     *
     * @param {GetMvpdProviderRequestAuthSuite} request - request
     * @returns {Promise<GetMvpdProviderResponseType>} - response
     */
    getMvpdProvider = (request) => {
        return this.providersService.getMvpdProvider(request);
    };
}
